/**
* author     : wangshaobin
* createTime : 2018-07-19
* description: 顶部
*/
<style scoped>
  .eghead{
    height:100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:0 30px;
    min-width: 1080px;
  }
  .eghead .eghead_left{
    color: #fff;
    font-size:24px;
  }
  .eghead .eghead_right{
    color: #fff;
    font-size:20px;
    margin: 30px;
    display: flex;
    align-items: center;
    justify-content:center;
  }
  .eghead .userInfo{
    display: flex;
    justify-content:center;
    align-items: center;
    margin: 0 30px;
  }
  .eghead .out{
    display: flex;
    justify-content:center;
    align-items: center;
    cursor: pointer;
    position: relative;
  }
  .eghead .out img:hover{
    width:75px;
  }
  .eghead .userInfo img{
    width:60px;
    margin-right: 10px;
  }
  .eghead .out img{
    width:60px;
    position: absolute;
    margin-left: 10px;
    padding: 10px;
    transition: all 0.4s;
  }
</style>

<template>
    <div class="eghead">
      <div class="eghead_left">Egolm项目在线翻译管理</div>
      <div class="eghead_right">
         <div class="userInfo">
           <img src="../../assets/img/icon/user.png"/> {{this.$store.state.sessionUser.name}}
         </div>
        <div class="out" @click="out">
          <img src="../../assets/img/icon/out.png"/>
        </div>
      </div>
    </div>
</template>

<script>
  import util from '../../util'
  import Watermark from '../../watermark'
    export default {
        name: 'eghead',
        props: [],
        components: {},
        data(){
            return {}
        },
        beforeCreate(){

        },
        created(){

        },
        beforeMount(){

        },
        mounted(){

        },
        methods: {
          out(){

            this.$axios.post('/logout').then(response => {
              this.$store.state.watermarkStatus = false;
              this.$store.state.loginStatus = false;
              this.$store.state.sessionUser = {}
              sessionStorage.removeItem(util.appKey());
              this.$router.push({ path: '/' });
            })


          }
        },
        beforeUpdate(){

        },
        updated(){

        },
        beforeDestroy(){

        },
        destroyed(){

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/frame/eghead.vue